import Vue from 'vue';
import moment from 'moment';

export default {
  name: 'Step',
  components: {
    TimeComp: require('../../../components/time.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appData: {
        jobcardId: 0,
        StepId: 0,
        Name: '',
        Comment: '',
        ActualTime: '',
        OutcomeTypeId: 0,
        OutcomeId: 0,
        ItemSerialNo: '',
        ReadingDateTime: moment(new Date()).format('YYYY-MM-DD'),
        Reading: 0,
        ConditionId: 0,
        ConditionComment: '',
      },
      conditions: [],
      allOutcomes: [],
      outcomes: [],
      outcomeTypes: [],
      showDate: { scheduledDateTime: false },
      disabledDates: date => {
        return (date < this.appData.startDateTime) || (date > this.appData.endDateTime);
      },
      componentKey: 0,
      stationId: 0,
      allEmployees: [],
      scheduledDateTime: {},
      scheduledTime: { hours: 0, minutes: 0, descr: 'manpowers.ScheduledTime', isReadOnly: false },
    }
  },
  computed: {
    employee: function () {
      return this.appData.employee;
    },
    scheduledTimeHours: function () {
      return this.scheduledTime.hours;
    },
    scheduledTimeMinutes: function () {
      return this.scheduledTime.minutes;
    },
  },
  watch: {
    stationId: function (value) {
      this.appData.availableEmployees = (this.stationId < 1) ? this.allEmployees : this.allEmployees.filter(item => item.stationId == this.stationId);
    },
    employee: function (value) {
      if (value.employeeId && this.$refs.select)
        this.$refs.select.open = false;
    },
    scheduledTimeHours: function (value) {
      this.appData.scheduledTimeHH = value;
    },
    scheduledTimeMinutes: function (value) {
      this.appData.scheduledTimeMin = value;
    }
  },
  created() {
    this.init();
    this.$root.$on('add_step_started', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.dataObj.ReadingDateTime = moment(new Date()).format('YYYY-MM-DD');
        this.appData = this.dataObj;
        this.conditions = this.appData.conditions;
        this.allOutcomes = this.appData.allOutcomes;
        this.outcomes = this.appData.allOutcomes;
        this.outcomeTypes = this.appData.outcomeTypes;
        this.componentKey++;
      });
    },
  },
}

